const BLOCK_SELECTOR = ".site-main > section";
const PENDING_CLASS = "block-reveal--pending";
const VISIBLE_CLASS = "block-reveal--visible";
const EXCLUDED_SELECTOR = [
	".hero--home-split",
	"[data-hero-centered-reveal]",
	".notice-bar-section",
	".intro-block",
	".entry-carousel--treatments",
	".entry-carousel--team",
	".image-feature--centeredText",
	".two-column--equal.two-column--gap-noGap",
	".background-wash-reveal-target",
].join(",");

function shouldRevealBlock(block) {
	return !block.matches(EXCLUDED_SELECTOR);
}

export function initBlockReveals() {
	const blocks = [...document.querySelectorAll(BLOCK_SELECTOR)].filter(shouldRevealBlock);

	if (!blocks.length) {
		return;
	}

	if (!("IntersectionObserver" in window)) {
		for (const block of blocks) {
			block.classList.add(VISIBLE_CLASS);
		}

		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) {
					continue;
				}

				entry.target.classList.add(VISIBLE_CLASS);
				observer.unobserve(entry.target);
			}
		},
		{
			threshold: 0.16,
		},
	);

	for (const block of blocks) {
		block.classList.add(PENDING_CLASS);
		observer.observe(block);
	}
}
